<template>
  <!--Dialog tthis.ipo de relatorio-->
  <v-dialog v-model="dialog" max-width="450px" content-class="bra-20">
    <v-card>
      <v-card-title>
        <span class="font-18 font-weight-medium">Tipo do relatório</span>

        <v-spacer />

        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="mt-2">
        <v-select
          v-model="tipo"
          :items="selects"
          label="Selecione o Tipo Relatório"
          outlined
          hide-details
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn color="primary" text @click="execReport()">Gerar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import $axios from './../../../api/api.js';
import api from "@/api/api";

export default {
  props: ["id", "dialog"],
  data() {
    return {
      tipo: "",
      selects: [
        { value: 1, text: "Relatório em PDF" },
        { value: 4, text: "Relatório em PDF (Código de Barras)" },
        { value: 2, text: "Relatório em Excel" },
        { value: 3, text: "Relatório em CSV" },
      ],
    };
  },
  mounted() {
    api.get("/relatorios/personalizados/barriga-verde/verificar-cliente")
      .then((res) => {
        const {cliente_correto} = res.data;
        if (cliente_correto) {
          this.selects.push({ value: 5, text: "Relatório em PDF (Barriga Verde)" });
        }
      })
  },
  methods: {
    execReport() {
      const token = localStorage.getItem("token");
      if (this.tipo === 1) {
        var u = "relatorio_romaneio_drp2";
      } else if (this.tipo === 2) {
        var u = "relatorio_romaneio_drp2_excel";
      } else if (this.tipo === 5) {
        var u = "relatorios/personalizados/barriga-verde/pdf-romaneio";
      } else if (this.tipo === 4) {
        var u = "relatorio_romaneio_drp2_codigo_barras";
      } else {
        var u = "relatorio_romaneio_drp2_csv";
      }
      let url = `${u}?systock=grupo&token=${token}&pedido=${this.id}`;
      window.open($axios.defaults.baseURL + "/" + url, "_blank");
      this.tipo = "";
      this.$emit("rClose", false);
    },
    close() {
      this.$emit("rClose", false);
    },
  },
};
</script>
